var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.readyStateComplete)?_c('div',[_c('router-view')],1):_c('div',{staticClass:"pt-5 mt-5"},[_c('img',{attrs:{"src":"https://images.avishkaar.cc/workflow/hp_v1/loader_new.gif","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }